import { render, staticRenderFns } from "./_coursesId.vue?vue&type=template&id=620fee88&scoped=true&"
import script from "./_coursesId.vue?vue&type=script&lang=js&"
export * from "./_coursesId.vue?vue&type=script&lang=js&"
import style0 from "./_coursesId.vue?vue&type=style&index=0&id=620fee88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620fee88",
  null
  
)

export default component.exports